<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent: 00em;">For my family, Debra, Amelia, Mat and Heather whose support and tolerance enabled me to have an interesting and successful career, and to write this book.</p><br/>
<p style="text-indent: 00em;">And for the staff and young people everywhere who spend time in residential care.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?dd6a06a2